module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.statuses), function(status) {
    return _c('div', [_vm._v(_vm._s(status))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d42174b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LecturerStatus.vue
// module id = 86
// module chunks = 1 2